import { render, staticRenderFns } from "./SystemBubble.vue?vue&type=template&id=4fc5b65e&scoped=true&"
import script from "./SystemBubble.vue?vue&type=script&lang=js&"
export * from "./SystemBubble.vue?vue&type=script&lang=js&"
import style0 from "./SystemBubble.vue?vue&type=style&index=0&id=4fc5b65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc5b65e",
  null
  
)

export default component.exports